import { IDocUnit, IModuleParams } from './types'

export function getUnitCourseName(params: IModuleParams) {
  return params.metadata.hasPart[0].isPartOf.name
}

export function getUnitDayTotal(params: IModuleParams) {
  return params.metadata.hasPart.reduce((acc, part) => {
    return (
      acc +
      part.hasPart.reduce((acc, unitPart) => {
        const match = unitPart.timeRequired.match(/\d+/)
        return acc + (match ? parseInt(match[0], 10) : 0)
      }, 0)
    )
  }, 0)
}

export function getModuleLessonCount(params: IModuleParams) {
  return params.metadata.hasPart.reduce((acc, part) => {
    return acc + getUnitLessonCount(part)
  }, 0)
}

function getUnitLessonCount(params: IDocUnit) {
  return params.hasPart.length
}
